import { render } from "./CountdownTimer.vue?vue&type=template&id=48477171&scoped=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=js"
export * from "./CountdownTimer.vue?vue&type=script&lang=js"

import "./CountdownTimer.vue?vue&type=style&index=0&id=48477171&scoped=true&lang=css"

import exportComponent from "/Volumes/directory/IdeaProjects/Macau-Double-Color-Ball/Macau-Double-Color-Ball_Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48477171"]])

export default __exports__